"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcMenuV2Behavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_menu_v2_responsive_1 = require("./bc-menu-v2-responsive/bc-menu-v2-responsive");
var bc_menu_v2_constants_1 = require("./bc-menu-v2-constants");
var bc_menu_v2_generator_1 = require("./bc-menu-v2-generator");
var bc_menu_v2_logout_1 = require("./bc-menu-v2-logout");
var bc_menu_v2_submenu_1 = require("./bc-menu-v2-submenu");
var bc_menu_v2_megamenu_1 = require("./bc-menu-v2-megamenu");
var BcMenuV2Behavior = (function (_super) {
    __extends(BcMenuV2Behavior, _super);
    function BcMenuV2Behavior(config) {
        var _this = _super.call(this) || this;
        _this.previousBreakpoint = null;
        _this.setId(config.id);
        _this.configurationMenu(config.configMenu);
        _this.eventLogout = config.eventLogout;
        _this.eventClickItem = config.eventClickItem;
        _this.setUp();
        return _this;
    }
    BcMenuV2Behavior.prototype._setUp = function () {
        var _this = this;
        this.menu = this.mySelf.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2));
        this.listElementsMenu = this.mySelf.querySelectorAll(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2));
        this.configDeploy();
        this.bcMenuV2Submenu = new bc_menu_v2_submenu_1.BcMenuV2Submenu(this.mySelf, this.configHeaderMegaMenu.bind(this));
        this.bcMenuV2MegaMenu = new bc_menu_v2_megamenu_1.BcMenuV2MegaMenu(this.listElementsMenu, this.configHeaderMegaMenu.bind(this), this.deleteClassActiveMegaMenu.bind(this), this.deleteClassPressItems.bind(this), this.toogleOpenCloseMegaMenu.bind(this), this.megaMenuButton);
        this.listennerResize();
        this.validateResize();
        this.validateResponsiveFirstLoad(this.menuConfiguration);
        this.bcResponsiveMenuV2.onGetMySelf = function () {
            return _this.mySelf;
        };
        this.bcGeneratorMenu.onDeleteClassActiveItems = function () {
            _this.deleteClassActiveItems();
        };
        this.bcGeneratorMenu.onDeleteClassPressItems = function () {
            _this.deleteClassPressItems();
        };
        this.bcGeneratorMenu.onDeleteMegaMenu = function () {
            _this.deleteActiveClassMegaMenu();
        };
        this.bcGeneratorMenu.onEventGenerator = function (returnEvent, event) {
            _this.eventClickItem(returnEvent, event);
        };
        this.bcGeneratorMenu.onToogleOpenCloseMegamenu = function (liElement) {
            _this.toogleOpenCloseMegaMenu(liElement);
        };
        this.bcResponsiveMenuV2.onEventResponsive = function (returnEvent, event) {
            _this.eventClickItem(returnEvent, event);
        };
        this.bcResponsiveMenuV2.onDeleteClassActiveItems = function () {
            _this.deleteClassActiveItems();
        };
        this.bcResponsiveMenuV2.onDeleteClassPressItems = function () {
            _this.deleteClassPressItems();
        };
        this.bcResponsiveMenuV2.eventLogoutResponsive = function (returnEvent, event) {
            _this.eventLogout(returnEvent, event);
        };
        this.verifyPaddingHeaderMenuAndFooterMobile();
        this.adjustEllipsis();
    };
    BcMenuV2Behavior.prototype.verifyPaddingHeaderMenuAndFooterMobile = function () {
        var _this = this;
        var fixedHeader = document.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_FIXED_HEADER));
        var menu = document.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MAIN_MENU_V2));
        var menuHeader = document.getElementsByClassName("".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2, " ").concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_HEADER))[common_constants_1.COMMON_CONSTANTS_NUMBERS.N0];
        var menuContent = document.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_CONTENT));
        var breakpoint = this.getBreakpoint(window.innerWidth);
        if (menuHeader) {
            var diferenceHeigth_1 = menuHeader.clientHeight * common_constants_1.COMMON_CONSTANTS_NUMBERS.N2 + bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_PADDING_MOBILE;
            if (this.isSafari()) {
                setTimeout(function () {
                    _this.setclientHeigt(fixedHeader, menu);
                    if (breakpoint == common_constants_1.BcCommonConstants.MOBILE || breakpoint == common_constants_1.BcCommonConstants.TABLET) {
                        menuContent.style.height = "".concat(menu.clientHeight - diferenceHeigth_1, "px");
                    }
                });
            }
            else {
                if (breakpoint == common_constants_1.BcCommonConstants.MOBILE) {
                    menuContent.style.height = "".concat(menu.clientHeight - diferenceHeigth_1, "px");
                }
            }
        }
    };
    BcMenuV2Behavior.prototype.clearHeightStyle = function () {
        var menuContent1 = document.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_CONTENT));
        menuContent1.style.height = '';
    };
    BcMenuV2Behavior.prototype.createElementHtml = function (element) {
        return document.createElement(element);
    };
    BcMenuV2Behavior.prototype.configurationMenu = function (menuConfig) {
        this.menuConfiguration = menuConfig;
        this.deploy = this.menuConfiguration.deploy;
        this.bcGeneratorMenu = new bc_menu_v2_generator_1.BcGeneratorMenu();
        this.bcGeneratorMenu.initMenu(this.menuConfiguration, this.mySelf);
        this.createLogoutIfNeeded(this.menuConfiguration);
        this.configHeader(this.menuConfiguration);
    };
    BcMenuV2Behavior.prototype.createLogoutIfNeeded = function (configMenu) {
        var _this = this;
        var _a;
        if (((_a = configMenu.logout) === null || _a === void 0 ? void 0 : _a.state) === bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE) {
            this.bcMenuV2Logout = new bc_menu_v2_logout_1.BcMenuV2Logout(this.mySelf, configMenu.logout);
            this.bcMenuV2Logout.onEventLogout = function () {
                _this.eventLogout();
            };
        }
    };
    BcMenuV2Behavior.prototype.configHeader = function (configMenu) {
        var menu = this.mySelf.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2));
        if (configMenu.header === bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE) {
            this.positionMenuHeaderFixed();
            menu.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_HEADER);
        }
        else {
            menu.classList.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_HEADER);
        }
    };
    BcMenuV2Behavior.prototype.positionMenuHeaderFixed = function () {
        var fixedHeader = document.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_FIXED_HEADER));
        var menu = document.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MAIN_MENU_V2));
        if (fixedHeader) {
            this.setclientHeigt(fixedHeader, menu);
        }
    };
    BcMenuV2Behavior.prototype.setclientHeigt = function (fixedHeader, menu) {
        menu.style.paddingTop = "".concat(fixedHeader.clientHeight, "px");
        if (fixedHeader.classList.contains(common_constants_1.BcCommonConstants.POSITION_FIXED_CLASS)) {
            fixedHeader.style.zIndex = '1';
        }
        else {
            fixedHeader.style.zIndex = '0';
        }
    };
    BcMenuV2Behavior.prototype.isSafari = function () {
        return bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_SAFARI_REGEX.test(navigator.userAgent);
    };
    BcMenuV2Behavior.prototype.validateResponsiveFirstLoad = function (subMenuConfig) {
        var configSubmenu = subMenuConfig;
        this.bcResponsiveMenuV2 = new bc_menu_v2_responsive_1.BcResponsiveMenuV2();
        var shouldRemoveCollapseClass = this.menu.classList.contains(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_COLAPSE);
        var innerWidth = window.innerWidth;
        if (innerWidth <= bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N991) {
            if (shouldRemoveCollapseClass) {
                this.menu.classList.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_COLAPSE);
            }
            if (innerWidth >= bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N767) {
                this.bcResponsiveMenuV2.ajustTablet(this.mySelf, configSubmenu);
            }
            else {
                this.bcResponsiveMenuV2.ajustMobile(this.mySelf, configSubmenu);
            }
        }
    };
    BcMenuV2Behavior.prototype.configDeploy = function () {
        var statusDeploy = !this.deploy ? bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE : this.deploy;
        var convertBoolean = function (statusMenu) {
            return statusMenu === common_constants_1.BcCommonConstants.TRUE;
        };
        this.toogle = convertBoolean(statusDeploy);
        statusDeploy === bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE
            ? this.menu.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_DEPLOY, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TYPE_FUNCTION)
            : this.closeMenu();
    };
    BcMenuV2Behavior.prototype.configHeaderMegaMenu = function (parentElement, elementItem, title, iconName, iconValue, elementItemEm) {
        var titleAtribute = parentElement.getAttribute(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ATR_TITLE);
        var iconAtribute = iconValue ? parentElement.getAttribute(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ATR_ICON) : iconName;
        var spanElement = elementItem;
        spanElement = title
            ? elementItem.insertBefore(this.createElementHtml(common_constants_1.BcCommonConstants.H5_TAG), elementItem.firstChild)
            : elementItem.insertBefore(this.createElementHtml(common_constants_1.BcCommonConstants.SPAN_TAG), elementItem.firstChild);
        var emElement = elementItemEm.insertBefore(this.createElementHtml(common_constants_1.BcCommonConstants.EM_TAG), elementItemEm.firstChild);
        emElement.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_SM_CLASS);
        spanElement.innerText = titleAtribute;
        emElement.innerText = iconAtribute;
        emElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_HIDDEN, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE);
    };
    BcMenuV2Behavior.prototype.openMenu = function (type) {
        if (type === void 0) { type = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TYPE_FUNCTION; }
        if (document.documentElement.clientWidth > bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N991) {
            this.menu.classList.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_COLAPSE);
            this.menu.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_DEPLOY, type);
            this.validateResize();
        }
    };
    BcMenuV2Behavior.prototype.closeMenu = function (type) {
        if (type === void 0) { type = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TYPE_FUNCTION; }
        if (document.documentElement.clientWidth > bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N991) {
            this.menu.classList.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_DEPLOY, type);
            this.menu.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_COLAPSE);
            this.validateResize();
            this.hoverOut();
        }
    };
    BcMenuV2Behavior.prototype.hoverOut = function () {
        var _this = this;
        var itemSubmenu = this.mySelf.querySelectorAll(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2));
        var hoverOutYes = false;
        var handleMouseOver = function () {
            if (_this.menu.classList.contains(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_COLAPSE)) {
                setTimeout(function () {
                    _this.openMenu();
                    hoverOutYes = true;
                }, 0);
            }
        };
        var handleMouseLeave = function () {
            setTimeout(function () {
                if (hoverOutYes) {
                    var hasActiveMegaMenu = Array.from(itemSubmenu).some(function (item) {
                        return item.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE));
                    });
                    if (hasActiveMegaMenu) {
                        _this.openMenu();
                    }
                    else {
                        _this.closeMenu();
                    }
                    _this.mutationSpy(itemSubmenu);
                }
                else {
                    _this.openMenu();
                }
                hoverOutYes = false;
            }, common_constants_1.COMMON_CONSTANTS_NUMBERS.N320);
        };
        this.menu.addEventListener(common_constants_1.BcCommonConstants.EVENT_MOUSEOVER, handleMouseOver);
        this.menu.addEventListener(common_constants_1.BcCommonConstants.EVENT_MOUSELEAVE, handleMouseLeave);
    };
    BcMenuV2Behavior.prototype.mutationSpy = function (submenuSpy) {
        var _this = this;
        var observers = [];
        var hasActiveMegaMenu = function () {
            return Array.from(submenuSpy).some(function (item) { return item.classList.contains(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE); });
        };
        var handleClassChange = function (mutationList) {
            if (hasActiveMegaMenu()) {
                _this.openMenu();
            }
            else {
                _this.closeMenu();
            }
        };
        submenuSpy.forEach(function (item) {
            var observer = new MutationObserver(handleClassChange);
            observer.observe(item, { attributes: true, attributeFilter: ['class'] });
            observers.push(observer);
        });
        setTimeout(function () {
            observers.forEach(function (observer) { return observer.disconnect(); });
        }, common_constants_1.COMMON_CONSTANTS_NUMBERS.N1024);
    };
    BcMenuV2Behavior.prototype.toogleMenu = function () {
        if (this.toogle) {
            this.openMenu();
            this.toogle = !this.toogle;
        }
        else {
            this.closeMenu();
            this.toogle = !this.toogle;
        }
    };
    BcMenuV2Behavior.prototype.listennerResize = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_RESIZE, function () {
            var width = window.innerWidth;
            var currentBreakpoint = _this.getBreakpoint(width);
            if (currentBreakpoint !== _this.previousBreakpoint) {
                _this.handleBreakpoint(currentBreakpoint);
                _this.previousBreakpoint = currentBreakpoint;
            }
            if (width >= bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N991) {
                _this.clearHeightStyle();
            }
            _this.verifyPaddingHeaderMenuAndFooterMobile();
            _this.verifyHeaderMenuClasess(width);
        });
    };
    BcMenuV2Behavior.prototype.verifyHeaderMenuClasess = function (width) {
        var headerMenuV2 = this.mySelf.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_HEADER));
        if (headerMenuV2) {
            if (this.getBreakpoint(width) == common_constants_1.BcCommonConstants.DESKTOP) {
                if (this.deploy == 'false') {
                    headerMenuV2.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_COLAPSE);
                }
                else {
                    headerMenuV2.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TYPE_FUNCTION);
                    headerMenuV2.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_DEPLOY);
                }
            }
            else {
                headerMenuV2.classList.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_COLAPSE);
                headerMenuV2.classList.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_DEPLOY);
                headerMenuV2.classList.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TYPE_FUNCTION);
            }
        }
    };
    BcMenuV2Behavior.prototype.getBreakpoint = function (width) {
        if (width <= bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N767) {
            return common_constants_1.BcCommonConstants.MOBILE;
        }
        else if (width <= bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N991) {
            return common_constants_1.BcCommonConstants.TABLET;
        }
        else {
            return common_constants_1.BcCommonConstants.DESKTOP;
        }
    };
    BcMenuV2Behavior.prototype.handleBreakpoint = function (breakpoint) {
        switch (breakpoint) {
            case common_constants_1.BcCommonConstants.MOBILE:
                this.menu.classList.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_COLAPSE);
                this.menu.classList.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_DEPLOY);
                this.bcResponsiveMenuV2.ajustMobile(this.mySelf, this.menuConfiguration);
                break;
            case common_constants_1.BcCommonConstants.TABLET:
                this.menu.classList.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_COLAPSE);
                this.menu.classList.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_DEPLOY);
                this.bcResponsiveMenuV2.ajustTablet(this.mySelf, this.menuConfiguration);
                break;
            case common_constants_1.BcCommonConstants.DESKTOP:
                this.configDeploy();
                this.ajustDesktop(this.mySelf, this.menuConfiguration);
                this.removeExtraMenuItemForDesktop();
                break;
            default:
                break;
        }
    };
    BcMenuV2Behavior.prototype.removeExtraMenuItemForDesktop = function () {
        var itemMore = document.getElementById(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ITEM_MORE);
        if (itemMore) {
            itemMore.remove();
        }
    };
    BcMenuV2Behavior.prototype.toogleOpenCloseMegaMenu = function (liElement) {
        var _this = this;
        var megaMenu = liElement.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2));
        if (window.innerWidth >= bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N991) {
            this.activateMegaMenuIfSubmenuIsActive(liElement, megaMenu);
            this.activateMegaMenuIfSubmenuIsNotActive(liElement, megaMenu);
            this.activateMegaMenuAndSubmenuIfOpen(liElement, megaMenu);
            this.activateMegaMenuAndSubmenuIfInactive(liElement, megaMenu);
            this.pressSubmenuAndActivateMegaMenuIfInactive(liElement, megaMenu);
            var elemento = document.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2));
            var callback = function () {
                _this.deleteActiveClassMegaMenu();
                _this.deleteClassPressItems();
            };
            this.detectOutsideClick(elemento, callback);
        }
    };
    BcMenuV2Behavior.prototype.pressSubmenuAndActivateMegaMenuIfInactive = function (liElement, megaMenu) {
        if (!liElement.classList.contains(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE) &&
            this.isActiveItem() &&
            !this.isMegamenuOpen()) {
            liElement.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_PRESS);
            megaMenu.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE);
        }
    };
    BcMenuV2Behavior.prototype.activateMegaMenuAndSubmenuIfInactive = function (liElement, megaMenu) {
        if (!liElement.classList.contains(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE) &&
            !this.isMegamenuOpen() &&
            !this.isActiveItem()) {
            this.deleteClassActiveItems();
            this.deleteActiveClassMegaMenu();
            this.deleteClassPressItems();
            megaMenu.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE);
            liElement.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE);
            liElement.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_CURRENT, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE);
            liElement.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_EXPANDED, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE);
        }
    };
    BcMenuV2Behavior.prototype.activateMegaMenuAndSubmenuIfOpen = function (liElement, megaMenu) {
        if (liElement.classList.contains(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE) && this.isMegamenuOpen()) {
            this.deleteClassActiveItems();
            this.deleteActiveClassMegaMenu();
            this.deleteClassPressItems();
            megaMenu.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE);
            liElement.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE);
            liElement.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_CURRENT, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE);
            liElement.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_EXPANDED, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE);
        }
    };
    BcMenuV2Behavior.prototype.activateMegaMenuIfSubmenuIsNotActive = function (liElement, megaMenu) {
        if (!liElement.classList.contains(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE) && this.isMegamenuOpen()) {
            this.deleteClassPressItems();
            this.deleteActiveClassMegaMenu();
            liElement.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_PRESS);
            megaMenu.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE);
        }
    };
    BcMenuV2Behavior.prototype.activateMegaMenuIfSubmenuIsActive = function (liElement, megaMenu) {
        if (liElement.classList.contains(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE) && !this.isMegamenuOpen()) {
            this.deleteClassActiveItems();
            this.deleteActiveClassMegaMenu();
            megaMenu.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE);
            liElement.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE);
            liElement.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_CURRENT, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE);
            liElement.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_EXPANDED, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE);
        }
    };
    BcMenuV2Behavior.prototype.isMegamenuOpen = function () {
        return this.mySelf.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE)) ? true : false;
    };
    BcMenuV2Behavior.prototype.isActiveItem = function () {
        return this.mySelf.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE)) ? true : false;
    };
    BcMenuV2Behavior.prototype.deleteClassActiveItems = function () {
        var items = this.mySelf.querySelectorAll(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2));
        items.forEach(function (item) {
            var _a;
            (_a = item.classList) === null || _a === void 0 ? void 0 : _a.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE);
            item.parentElement.setAttribute('aria-expanded', 'false');
        });
    };
    BcMenuV2Behavior.prototype.deleteClassPressItems = function () {
        var items = this.mySelf.querySelectorAll(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2));
        items.forEach(function (item) {
            var _a;
            (_a = item.classList) === null || _a === void 0 ? void 0 : _a.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_PRESS);
        });
    };
    BcMenuV2Behavior.prototype.deleteActiveClassMegaMenu = function () {
        var items = this.mySelf.querySelectorAll(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2));
        items.forEach(function (item) {
            var _a;
            var megaMenuActive = item.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE));
            if (megaMenuActive) {
                (_a = megaMenuActive === null || megaMenuActive === void 0 ? void 0 : megaMenuActive.classList) === null || _a === void 0 ? void 0 : _a.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE);
            }
        });
    };
    BcMenuV2Behavior.prototype.detectOutsideClick = function (elemento, callback) {
        var outsideClick = function (event) {
            if (!elemento.contains(event.target)) {
                callback();
            }
        };
        document.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, outsideClick);
        return function () {
            document.removeEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, outsideClick);
        };
    };
    BcMenuV2Behavior.prototype.deleteClassActiveMegaMenu = function () {
        this.listElementsMenu.forEach(function (subMenu) {
            var elementMegaMenu = subMenu.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2));
            if (elementMegaMenu) {
                elementMegaMenu.classList.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_ACTIVE);
                subMenu.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_CURRENT, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_FALSE);
                subMenu.parentElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_EXPANDED, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_FALSE);
            }
        });
    };
    BcMenuV2Behavior.prototype.validateResize = function () {
        var _this = this;
        if (window.innerWidth <= bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N991) {
            this.menu.classList.remove(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_DEPLOY);
        }
        window.addEventListener('resize', function () {
            if (window.innerWidth <= bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N991) {
                _this.deleteActiveClassMegaMenu();
                _this.deleteClassPressItems();
            }
        });
    };
    BcMenuV2Behavior.prototype.ajustDesktop = function (menu, subMenuConfig) {
        var listItemsMenu = menu.querySelector("#".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_LIST_ITEMS));
        var listItemsMenuArr = listItemsMenu.childNodes;
        if (listItemsMenuArr.length > common_constants_1.COMMON_CONSTANTS_NUMBERS.N5) {
            if (listItemsMenuArr[common_constants_1.COMMON_CONSTANTS_NUMBERS.N4].getAttribute(common_constants_1.BcCommonConstants.STYLE) ==
                bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER_DISPLAY) {
                for (var index = common_constants_1.COMMON_CONSTANTS_NUMBERS.N4; index < listItemsMenuArr.length; index++) {
                    listItemsMenuArr[index].style.display = common_constants_1.BcCommonConstants.BLOCK;
                }
                var targetA = listItemsMenuArr[listItemsMenuArr.length - common_constants_1.COMMON_CONSTANTS_NUMBERS.N1];
                targetA.remove();
            }
        }
        var popOvers = document.querySelectorAll(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER));
        if (!!popOvers) {
            this.bcResponsiveMenuV2.arrayInstancesPopOver.forEach(function (instance) {
                instance = null;
            });
            this.bcResponsiveMenuV2.arrayInstancesPopOver = [];
            popOvers.forEach(function (elementA) {
                elementA.remove();
            });
        }
    };
    BcMenuV2Behavior.prototype.cambiarActive = function (param) {
        var items = Array.from(this.mySelf.getElementsByClassName('bc-list-items-menu-v2')[0].children);
        items.forEach(function (item) {
            if (item.firstChild.getAttribute('title') == param) {
                item.firstChild.classList.add('bc-submenu-v2-active');
            }
            else {
                item.firstChild.classList.remove('bc-submenu-v2-active');
            }
        });
    };
    BcMenuV2Behavior.prototype.adjustEllipsis = function () {
        if (this.listElementsMenu.length) {
            Array.from(this.listElementsMenu).forEach(function (element) {
                var itemContainer = element.querySelector("".concat(common_constants_1.BcCommonConstants.SECTION_TAG, " ").concat(common_constants_1.BcCommonConstants.DIV_TAG));
                var spanElement = itemContainer.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
                var itemClon = spanElement.cloneNode(true);
                itemClon.style.visibility = common_constants_1.BcCommonConstants.HIDDEN;
                itemClon.style.wordBreak = common_constants_1.BcCommonConstants.NORMAL;
                itemClon.style.display = common_constants_1.BcCommonConstants.BLOCK;
                itemClon.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_LINE_CLAMP_N2);
                itemContainer.appendChild(itemClon);
                if (itemClon.getBoundingClientRect().width > spanElement.getBoundingClientRect().width) {
                    spanElement.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_LINE_CLAMP_N1);
                }
                else {
                    spanElement.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_LINE_CLAMP_N2);
                }
                itemContainer.removeChild(itemClon);
            });
        }
    };
    return BcMenuV2Behavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcMenuV2Behavior = BcMenuV2Behavior;
